import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

import { DisclosureComponent } from '../disclosure/disclosure.component';

@Component({
    selector: 'sirius-accordion-item',
    template: `
        <sirius-disclosure
            variant="region"
            triggerPosition="above"
            triggerIcon="plus-minus"
            labelTextStyleSize="l"
            [headingLevel]="3"
            [collapsedLabel]="title()"
            [expandedLabel]="title()"
            [headingId]="headingId()"
            [regionId]="regionId()"
            [(expanded)]="expanded"
        >
            <ng-content></ng-content>
        </sirius-disclosure>
    `,
    styleUrl: './accordion-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DisclosureComponent],
    host: {
        'class': 'sir-accordion-item sir-text-style-paragraph-m-bold',
        '[class.is-expanded]': 'expanded()',
    },
})
export class AccordionItemComponent {
    readonly title = input.required<string>();
    readonly expanded = model(false);
    readonly headingId = input<string | undefined>(undefined);
    readonly regionId = input<string | undefined>(undefined);
}
